import { render, staticRenderFns } from "./ThePaintPaletteIcon.vue?vue&type=template&id=080c29f0&"
import script from "./ThePaintPaletteIcon.vue?vue&type=script&lang=js&"
export * from "./ThePaintPaletteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports